const state = {
  financialStatusChanges: '',
  creditHistory: '',
  creditHistoryDetails: '',
  creditHistoryTwoYears: '',
  creditHistoryTwoYearsDetails: '',
  conflictOfInterest: '',
  isSuitable: '',
  isConsistent: '',
  canComply: '',
  isNotConsistent: '',
  canNotComply: '',
  purposeDetails: '',
  refinancingDetails: '',
  preferredLoanDetails: '',
  productDetails: '',
  financialStatusChangesDetails: '',
  conflictOfInterestDetails: '',

  // pepper start
  pepperCreditSubmission: false,
  whyDoesThisLoanTermSuitYourRequirements: '',
  whyDoesThisLoanTermSuitYourRequirementsDetails: '',
  whatAreYouLookingForInYourLoan: [],
  anyForeseeableChangesImpactingLoanRepayment: '',
  typeOfChangeExpected: '',
  howApplicantIntendToDoLoanRepaymentAfterChange: '',
  balloonPaymentAtTheEndOfTheLoan: 0,
  whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm: '',
  whyAreYouLookingAtRefinancing: '',
  detailedReasonForRefinancing: '',
  isApplicantPlanningToRetireBeforeLoanCompletion: 0,
  howTheApplicantProposeToRepayTheLoan: '',
  howTheApplicantProposeToRepayTheLoanDetails: '',
  // pepper end
};

const getters = {
  financialStatusChanges: state => state.financialStatusChanges,
  financialStatusChangesDetails: state => state.financialStatusChangesDetails,
  creditHistory: state => state.creditHistory,
  creditHistoryDetails: state => state.creditHistoryDetails,
  creditHistoryTwoYears: state => state.creditHistoryTwoYears,
  creditHistoryTwoYearsDetails: state => state.creditHistoryTwoYearsDetails,
  conflictOfInterest: state => state.conflictOfInterest,
  conflictOfInterestDetails: state => state.conflictOfInterestDetails,
  isSuitable: state => state.isSuitable,
  isConsistent: state => state.isConsistent,
  canComply: state => state.canComply,
  isNotConsistent: state => state.isNotConsistent,
  canNotComply: state => state.canNotComply,
  purposeDetails: state => state.purposeDetails,
  refinancingDetails: state => state.refinancingDetails,
  preferredLoanDetails: state => state.preferredLoanDetails,
  productDetails: state => state.productDetails,
  // pepper start
  pepperCreditSubmission: state => state.pepperCreditSubmission,
  whyDoesThisLoanTermSuitYourRequirements: state => state.whyDoesThisLoanTermSuitYourRequirements,
  whyDoesThisLoanTermSuitYourRequirementsDetails: state => state.whyDoesThisLoanTermSuitYourRequirementsDetails,
  whatAreYouLookingForInYourLoan: state => state.whatAreYouLookingForInYourLoan,
  anyForeseeableChangesImpactingLoanRepayment: state => state.anyForeseeableChangesImpactingLoanRepayment,
  typeOfChangeExpected: state => state.typeOfChangeExpected,
  howApplicantIntendToDoLoanRepaymentAfterChange: state => state.howApplicantIntendToDoLoanRepaymentAfterChange,
  balloonPaymentAtTheEndOfTheLoan: state => state.balloonPaymentAtTheEndOfTheLoan,
  whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm: state => state.whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm,
  whyAreYouLookingAtRefinancing: state => state.whyAreYouLookingAtRefinancing,
  detailedReasonForRefinancing: state => state.detailedReasonForRefinancing,
  isApplicantPlanningToRetireBeforeLoanCompletion: state => state.isApplicantPlanningToRetireBeforeLoanCompletion,
  howTheApplicantProposeToRepayTheLoan: state => state.howTheApplicantProposeToRepayTheLoan,
  howTheApplicantProposeToRepayTheLoanDetails: state => state.howTheApplicantProposeToRepayTheLoanDetails,
  // pepper end
};

const mutations = {
  saveFinancialStatusChanges(state, value) { state.financialStatusChanges = value },
  saveCreditHistory(state, value) { state.creditHistory = value },
  saveCreditHistoryTwoYears(state, value) { state.creditHistoryTwoYears = value },
  saveConflictOfInterest(state, value) { state.conflictOfInterest = value },
  saveIsSuitable(state, value) { state.isSuitable = value },
  saveIsSecured(state, value) { state.isSecured = value },
  saveIsConsistent(state, value) { state.isConsistent = value },
  saveCanComply(state, value) { state.canComply = value },
  saveIsNotConsistent(state, value) { state.isNotConsistent = value },
  saveCanNotComply(state, value) { state.canNotComply = value },
  savePurposeDetails(state, details) { state.purposeDetails = details },
  saveRefinancingDetails(state, details) { state.refinancingDetails = details },
  savePreferredLoanDetails(state, details) { state.preferredLoanDetails = details },
  saveFinancialStatusChangesDetails(state, details) { state.financialStatusChangesDetails = details },
  saveCreditHistoryDetails(state, details) { state.creditHistoryDetails = details },
  saveCreditHistoryTwoYearsDetails(state, details) { state.creditHistoryTwoYearsDetails = details },
  saveConflictOfInterestDetails(state, details) { state.conflictOfInterestDetails = details },
  saveProductDetails(state, details) { state.productDetails = details },
  // pepper start
  savePepperCreditSubmission(state, details) { state.pepperCreditSubmission = details },
  saveWhyDoesThisLoanTermSuitYourRequirements(state, details) { state.whyDoesThisLoanTermSuitYourRequirements = details },
  saveWhyDoesThisLoanTermSuitYourRequirementsDetails(state, details) { state.whyDoesThisLoanTermSuitYourRequirementsDetails = details },
  saveWhatAreYouLookingForInYourLoan(state, details) { state.whatAreYouLookingForInYourLoan = details },
  saveAnyForeseeableChangesImpactingLoanRepayment(state, details) { state.anyForeseeableChangesImpactingLoanRepayment = details },
  saveTypeOfChangeExpected(state, details) { state.typeOfChangeExpected = details },
  saveHowApplicantIntendToDoLoanRepaymentAfterChange(state, details) { state.howApplicantIntendToDoLoanRepaymentAfterChange = details },
  saveBalloonPaymentAtTheEndOfTheLoan(state, details) { state.balloonPaymentAtTheEndOfTheLoan = details },
  saveWhatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm(state, details) { state.whatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm = details },
  saveWhyAreYouLookingAtRefinancing(state, details) { state.whyAreYouLookingAtRefinancing = details },
  saveDetailedReasonForRefinancing(state, details) { state.detailedReasonForRefinancing = details },
  saveIsApplicantPlanningToRetireBeforeLoanCompletion(state, details) { state.isApplicantPlanningToRetireBeforeLoanCompletion = details },
  saveHowTheApplicantProposeToRepayTheLoan(state, details) { state.howTheApplicantProposeToRepayTheLoan = details },
  saveHowTheApplicantProposeToRepayTheLoanDetails(state, details) { state.howTheApplicantProposeToRepayTheLoanDetails = details },
  // pepper end
};
const actions = {
  saveFinancialStatusChanges(context, value) { context.commit('saveFinancialStatusChanges', value) },
  saveCreditHistory(context, value) { context.commit('saveCreditHistory', value) },
  saveCreditHistoryTwoYears(context, value) { context.commit('saveCreditHistoryTwoYears', value) },
  saveConflictOfInterest(context, value) { context.commit('saveConflictOfInterest', value) },
  saveIsSuitable(context, value) { context.commit('saveIsSuitable', value) },
  saveIsSecured(context, value) { context.commit('saveIsSecured', value) },
  saveIsConsistent(context, value) { context.commit('saveIsConsistent', value) },
  saveCanComply(context, value) { context.commit('saveCanComply', value) },
  saveIsNotConsistent(context, value) { context.commit('saveIsNotConsistent', value) },
  saveCanNotComply(context, value) { context.commit('saveCanNotComply', value) },
  savePurposeDetails(context, details) { context.commit('savePurposeDetails', details) },
  saveRefinancingDetails(context, details) { context.commit('saveRefinancingDetails', details) },
  savePreferredLoanDetails(context, details) { context.commit('savePreferredLoanDetails', details) },
  saveFinancialStatusChangesDetails(context, details) { context.commit('saveFinancialStatusChangesDetails', details) },
  saveCreditHistoryDetails(context, details) { context.commit('saveCreditHistoryDetails', details) },
  saveCreditHistoryTwoYearsDetails(context, details) { context.commit('saveCreditHistoryTwoYearsDetails', details) },
  saveConflictOfInterestDetails(context, details) { context.commit('saveConflictOfInterestDetails', details) },
  saveProductDetails(context, details) { context.commit('saveProductDetails', details) },
  // pepper start
  savePepperCreditSubmission(context, details) { context.commit('savePepperCreditSubmission', details) },
  saveWhyDoesThisLoanTermSuitYourRequirements(context, details) { context.commit('saveWhyDoesThisLoanTermSuitYourRequirements', details) },
  saveWhyDoesThisLoanTermSuitYourRequirementsDetails(context, details) { context.commit('saveWhyDoesThisLoanTermSuitYourRequirementsDetails', details) },
  saveWhatAreYouLookingForInYourLoan(context, details) { context.commit('saveWhatAreYouLookingForInYourLoan', details) },
  saveAnyForeseeableChangesImpactingLoanRepayment(context, details) { context.commit('saveAnyForeseeableChangesImpactingLoanRepayment', details) },
  saveTypeOfChangeExpected(context, details) { context.commit('saveTypeOfChangeExpected', details) },
  saveHowApplicantIntendToDoLoanRepaymentAfterChange(context, details) { context.commit('saveHowApplicantIntendToDoLoanRepaymentAfterChange', details) },
  saveBalloonPaymentAtTheEndOfTheLoan(context, details) { context.commit('saveBalloonPaymentAtTheEndOfTheLoan', details) },
  saveWhatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm(context, details) { context.commit('saveWhatToDoWithBalloonPaymentAtTheEndOfTheLoanTerm', details) },
  saveWhyAreYouLookingAtRefinancing(context, details) { context.commit('saveWhyAreYouLookingAtRefinancing', details) },
  saveDetailedReasonForRefinancing(context, details) { context.commit('saveDetailedReasonForRefinancing', details) },
  saveIsApplicantPlanningToRetireBeforeLoanCompletion(context, details) { context.commit('saveIsApplicantPlanningToRetireBeforeLoanCompletion', details) },
  saveHowTheApplicantProposeToRepayTheLoan(context, details) { context.commit('saveHowTheApplicantProposeToRepayTheLoan', details) },
  saveHowTheApplicantProposeToRepayTheLoanDetails(context, details) { context.commit('saveHowTheApplicantProposeToRepayTheLoanDetails', details) },
  // pepper end
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
